import * as React from 'react';
import { useInject } from 'dependable-react';
import { css } from 'emotion';

import { Button } from './Button';
import { I18N_TOKEN } from '../services/InjectTokens';
import { BREAKPOINT_SMALL } from '../consts/breakpoints';

const continueButton = css`
  margin-left: 0px;

  @media (min-width: ${BREAKPOINT_SMALL}) {
    margin-left: 40px;
  }
`;

interface IFlow {
  magic: {
    show: boolean;
    onClick(): void;
  };
  back: {
    show: boolean;
    onClick(): void;
  };
  nextAvatar: {
    show: boolean;
    disabled: boolean;
    onClick(): void;
  };
  addToCart: {
    show: boolean;
    disabled: boolean;
    onClick(): void;
  };
  continueProducts: {
    show: boolean;
    onClick(): void;
  };
  nextMoreMagic: {
    show: boolean;
    disabled: boolean;

    onClick(): void;
  };
}

export function FlowButtons({ magic, back, nextAvatar, addToCart, continueProducts, nextMoreMagic }: IFlow) {
  const i18n = useInject(I18N_TOKEN);

  return (
    <React.Fragment>
      {magic.show && <Button isMagic value={i18n.t('more_magic_button')} onClick={magic.onClick} />}
      {back.show && <Button value={i18n.t('go_back')} onClick={back.onClick} className={continueButton} />}
      {nextAvatar.show && (
        <>
          <Button
            value={i18n.t('continue')}
            onClick={nextAvatar.onClick}
            className={continueButton}
            isDisabled={nextAvatar.disabled}
          />
        </>
      )}
      {nextMoreMagic.show && (
        <>
          <Button
            value={i18n.t('continue')}
            onClick={nextMoreMagic.onClick}
            className={continueButton}
            isDisabled={nextMoreMagic.disabled}
          />
        </>
      )}
      {/*  {addToCart.show && (
        <Button
          value={i18n.t('add_to_cart')}
          onClick={addToCart.onClick}
          className={continueButton}
          isDisabled={addToCart.disabled}
        />
      )} */}
      {continueProducts.show && (
        <Button value={i18n.t('continue')} onClick={continueProducts.onClick} className={continueButton} />
      )}
    </React.Fragment>
  );
}
